module.exports = __webpack_public_path__ + "img/qrcode-grey24.6d808c86.svg";